// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1YLjt","productName":"Table_productName__3oiP4"};